<div class="table-responsive">
  <ng-content></ng-content>
</div>
